export default __webpack_public_path__ + "assets/a3.5abba496.jpg";